
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { checkUserApi } from "../http/http";
import { useTranslation } from "react-i18next";

const Auth = ({ children }) => {
  const location = useLocation();
  const { t } = useTranslation();

  const user = useSelector(
    (state) =>
      state?.persisted?.userSlice?.user ??
      state?.persisted?.userSlice ??
      null
  );

  const [checking, setChecking] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const [lowBalance, setLowBalance] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const verifySubscription = async () => {
      setChecking(true);
      setAuthorized(false);
      setLowBalance(false);

      const storedMsisdn =
        localStorage.getItem("msisdn") || user?.msisdn;

      if (!storedMsisdn) {
        setChecking(false);
        return;
      }

      // Normalize the number to digits and ensure the Gabon prefix.
      const digits = storedMsisdn.replace(/\D/g, "");
      const msisdn = digits.startsWith("241")
        ? digits
        : `241${digits.startsWith("0") ? digits.slice(1) : digits}`;

      try {
        const response = await checkUserApi(msisdn);
        const data = response?.data;
        const status = data?.data?.status;

        if (cancelled) return;

        if (data?.success && status === 1) {
          setAuthorized(true);
        } else if (
          status === 0 ||
          data?.message?.toLowerCase().includes("low balance")
        ) {
          setLowBalance(true);
        }
      } catch (error) {
        if (cancelled) return;

        const data = error?.response?.data;
        const status = data?.result?.status ?? data?.data?.status;

        if (
          status === 0 ||
          data?.message?.toLowerCase().includes("low balance")
        ) {
          setLowBalance(true);
        } else {
          // Fail closed: do not grant access if verification fails.
          localStorage.removeItem("msisdn");
          setAuthorized(false);
        }
      } finally {
        if (!cancelled) setChecking(false);
      }
    };

    verifySubscription();

    return () => {
      cancelled = true;
    };
  }, [user?.msisdn]);

  if (checking) {
    return <div>{t("167")}</div>;
  }

  if (lowBalance) {
    return <Navigate to="/low-balance" replace />;
  }

  if (!authorized) {
    return (
      <Navigate
        to="/subscribe"
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};

export default Auth;
